import { OrderDetail, OrderItem } from "../../orders/model/orderDetail.ui";
import { ProposalDetailResponse } from "./proposalDetail.api";

export interface ProposalDetail {
    propose_id?: number;
    propose_code?: string;
    representative_id?: string;
    recipient_id?: number;
    recipient_name?: string;
    effective_from?: Date;
    effective_to?: Date;
    estimated_delivery_date?: Date;
    estimated_receipt_date?: Date;
    note?: string;
    expires_at?: Date;
    status?: string;
    created_at?: Date;
    updated_at?: Date;
    delete_at?: Date;
    items?: Item[];
}

export interface Item {
    propose_item_id?: number;
    product_code?: string;
    product_name?: string;
    origin?: string;
    shipper?: string;
    grade?: string;
    size?: string;
    scale?: string;
    package?: string;
    quantity_per_package?: number;
    wholesale_price?: string;
    price?: string;
    note?: string;
    schedules?: Schedule[];
}

export interface Schedule {
    propose_schedule_id?: number;
    delivery_date?: Date;
    quantity?: number;
}

export const ConvertProposalDetail = (data: ProposalDetailResponse): ProposalDetail => {
    return {
        propose_id: data?.propose_id ?? 0,
        propose_code: data?.propose_code ?? "",
        representative_id: data?.representative_id ?? "",
        recipient_id: data?.recipient_id ?? 0,
        recipient_name: data?.recipient_name ?? "",
        effective_from: data?.effective_from ?? new Date(),
        effective_to: data?.effective_to ?? new Date(),
        estimated_delivery_date: data?.estimated_delivery_date ?? new Date(),
        estimated_receipt_date: data?.estimated_receipt_date ?? new Date(),
        note: data?.note ?? "",
        expires_at: data?.expires_at ?? new Date(),
        status: data?.status ?? "",
        created_at: data?.created_at ?? new Date(),
        updated_at: data?.updated_at ?? new Date(),
        delete_at: data?.delete_at ?? new Date(),
        items: data?.items?.map((item): Item => ({
            propose_item_id: item?.propose_item_id ?? 0,
            product_code: item?.product_code ?? "",
            product_name: item?.product_name ?? "",
            origin: item?.origin ?? "",
            shipper: item?.shipper ?? "",
            grade: item?.grade ?? "",
            size: item?.size ?? "",
            scale: item?.scale ?? "",
            package: item?.package ?? "",
            quantity_per_package: item?.quantity_per_package ?? 0,
            wholesale_price: item?.wholesale_price ?? "",
            price: item?.price ?? "",
            note: item?.note ?? "",
            schedules: item?.schedules?.map((schedule): Schedule => ({
                propose_schedule_id: schedule?.propose_schedule_id ?? 0,
                delivery_date: schedule?.delivery_date ?? new Date(),
                quantity: schedule?.quantity ?? 0,
            })) ?? [],
        })) ?? [],
    };
};

export const ConvertProposalToOrderDetail = (proposal: ProposalDetail): OrderDetail => {
    return {
        order_id: proposal.propose_id,
        sales_date: proposal.effective_from,
        status: proposal.status,
        created_at: proposal.created_at,
        updated_at: proposal.updated_at,
        order_items: proposal.items?.map((item): OrderItem => {
            return {
                item_id: item?.propose_item_id ?? 0,
                product_code: item?.product_code ?? "",
                product_name: item?.product_name ?? "",
                grade: item?.grade ?? "",
                quantity_per_package: item?.quantity_per_package ?? 0,
                order_unit: item?.package ?? "",
                is_selected: true,
            };
        }),
    };
}
    